import { ApiError, api } from "@/lib/api";

export type ProductAccessRoleOption = {
  value: string;
  label: string;
};

export type ProductAccessToolItem = {
  key: string;
  name: string;
  role: string | null;
  roles: ProductAccessRoleOption[];
};

export type ProductAccessBrandItem = {
  id: number;
  name: string;
  role: string | null;
  roles: ProductAccessRoleOption[];
  tools: ProductAccessToolItem[];
};

export type ProductAccessPayload = {
  user_id: number;
  brands: ProductAccessBrandItem[];
};

export type ProductAccessUpdateTool = {
  key: string;
  role: string | null;
};

export type ProductAccessUpdateBrand = {
  id: number;
  role: string | null;
  tools?: ProductAccessUpdateTool[];
};

/** 下拉「无」的哨兵值（API 用 null） */
export const ROLE_NONE = "none";

export async function fetchProductAccess(
  accountId: string | number,
  membershipId: number,
): Promise<ProductAccessPayload> {
  return api.fetchForAccount<ProductAccessPayload>(
    accountId,
    `/accounts/${accountId}/memberships/${membershipId}/product_access`,
  );
}

export async function updateProductAccess(
  accountId: string | number,
  membershipId: number,
  brands: ProductAccessUpdateBrand[],
): Promise<ProductAccessPayload> {
  return api.fetchForAccount<ProductAccessPayload>(
    accountId,
    `/accounts/${accountId}/memberships/${membershipId}/product_access`,
    {
      method: "PATCH",
      body: JSON.stringify({ brands }),
    },
  );
}

export async function enableBrandTool(
  accountId: string | number,
  brandId: string | number,
  product: string,
): Promise<{ tool: { id: number; product: string; name: string } }> {
  return api.fetchForAccount(
    accountId,
    `/accounts/${accountId}/brands/${brandId}/tools`,
    {
      method: "POST",
      body: JSON.stringify({ product }),
    },
  );
}

export { ApiError };
